import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useLocale } from '../contexts/LocaleContext'
import LanguageSwitcher from './LanguageSwitcher'

function Header() {
  const [open, setOpen] = useState(false)
  const { t, locale } = useLocale()
  const homePath = locale === 'fr' ? '/fr' : '/'
  const blogPath = locale === 'fr' ? '/fr/blog' : '/blog'
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 1024) setOpen(false)
    }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const handleNavigation = (path) => {
    setOpen(false)

    // If we're already on the home page and it's an anchor link, just scroll
    const onHome = location.pathname === '/' || location.pathname === '/fr'
    const hashIndex = path.indexOf('#')
    const hash = hashIndex >= 0 ? path.slice(hashIndex) : ''
    if (onHome && hash) {
      const element = document.querySelector(hash)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    } else {
      // Navigate to the path (this will trigger the useScrollToAnchor hook)
      navigate(path)
    }
  }

  return (
    <header className="site-header">
      <div className="container nav">
        <a className="brand" href={homePath} aria-label="Gym Journey home">
          <img src="/assets/logo_no_bg.svg" alt="Gym Journey logo" width="36" height="36" style={{ backgroundColor: 'white', padding: 4 }} />
          <span>Gym Journey</span>
        </a>

        <button className="nav-toggle" aria-expanded={open} aria-controls="primary-nav" onClick={() => setOpen(!open)}>
          <span className="sr-only">Toggle navigation</span>
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        <nav id="primary-nav" aria-label="Primary" className={open ? 'open' : ''}>
          <ul>
            <li><a href={homePath} onClick={(e) => { e.preventDefault(); handleNavigation(homePath) }}>{t.nav.home}</a></li>
            <li><a href={`${homePath}#features`} onClick={(e) => { e.preventDefault(); handleNavigation(`${homePath}#features`) }}>{t.nav.features}</a></li>
            <li><a href={`${homePath}#screenshots`} onClick={(e) => { e.preventDefault(); handleNavigation(`${homePath}#screenshots`) }}>{t.nav.screenshots}</a></li>
            <li><a href={`${homePath}#coach`} onClick={(e) => { e.preventDefault(); handleNavigation(`${homePath}#coach`) }}>{t.nav.coach}</a></li>
            <li><a href={blogPath} onClick={(e) => { e.preventDefault(); handleNavigation(blogPath) }}>{t.nav.blog}</a></li>
            <li><a href={`${homePath}#faq`} onClick={(e) => { e.preventDefault(); handleNavigation(`${homePath}#faq`) }}>{t.nav.faq}</a></li>
          </ul>
        </nav>

        <div className="cta">
          <LanguageSwitcher />
          <a className="btn primary" href={`${homePath}#download`} onClick={(e) => { e.preventDefault(); handleNavigation(`${homePath}#download`) }} aria-label="Download Gym Journey for iOS and Android">
            <span>{t.nav.download}</span>
          </a>
        </div>
      </div>
    </header>
  )
}

export default Header
